module.exports = __webpack_public_path__ + "static/media/send-comment.f41dd5b3.svg";